import React from "react";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";

const handleRenderOption = (option, { inputValue }) => {
  let nombre = `${option?.Nombre.trim()} ${option?.Apellidos.trim()}`
  const matches = match( `${option.Referencia} - ${nombre}`, inputValue);
  const parts = parse( `${option.Referencia} - ${nombre}`, matches);
  const highlightStyle = {
    fontWeight: 700,
    backgroundColor: "lightyellow",
    padding: "5px 2px",
  };
  return (
    <div>
      {parts.map((part, index) => (
        <span key={index} style={part.highlight ? highlightStyle : {}}>
          {part.text}
        </span>
      ))}
    </div>
  );
};

export default handleRenderOption;
